var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('div',[_vm._v("Text")]),_c('v-btn',{on:{"click":_vm.callAPI}},[_vm._v("Call API")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }